import gql from 'graphql-tag';

import actionTypes from './constants';

// import helpers from './../../helpers';

export const getExercises = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_EXERCISES}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => ({ exercises: data.getExercises }));

export const setMembershipSchedule = (client, variables) => client
    .mutate({
      mutation: gql`
        ${actionTypes.gql.SET_MEMBERSHIP_SCHEDULE}
      `,
      variables,
    })
    .then((res) => res.data)
    .then((data) => ({ membershipSchedule: data.setMembershipSchedule }));

export const setMembershipPayment = (client, variables) => client
    .mutate({
      mutation: gql`
        ${actionTypes.gql.SET_MEMBERSHIP_PAYMENT}
      `,
      variables,
    })
    .then((res) => res.data)
    .then((data) => ({ membershipPayment: data.setMembershipPayment }));

/* */
export const getMemberships = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_MEMBERSHIPS}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.getMemberships);

/* */
export const subscribe = (client, variables) => client
    .mutate({
      mutation: gql`
        ${actionTypes.gql.SUBSCRIBE}
      `,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.subscribeMembership);

// To master server
export const checkMembershipSchedule = (client, variables) => client
    .mutate({
      mutation: gql`
        ${actionTypes.gql.CHECK_MEMBERSHIP_SCHEDULE}
      `,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.checkMembershipSchedule);
